import { render, staticRenderFns } from "./case_studies.vue?vue&type=template&id=b24713f6&scoped=true&"
import script from "./case_studies.vue?vue&type=script&lang=js&"
export * from "./case_studies.vue?vue&type=script&lang=js&"
import style0 from "./case_studies.vue?vue&type=style&index=0&id=b24713f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24713f6",
  null
  
)

export default component.exports